import React from 'react';
import styled from 'styled-components';
import { Text, color } from '@starrez/starryui9';

interface IOptionProps {
    caption: string;
    onClick?: () => void;
}

export const Option = ({ caption, onClick }: IOptionProps) => {
    const handleOnClick = () => {
        onClick && onClick();
    };

    return (
        <li>
            <StyledButton type="button" onClick={handleOnClick}>
                <Text color={color.Grey.G80} variant="normal.regular">
                    {caption}
                </Text>
            </StyledButton>
        </li>
    );
};

const StyledButton = styled.button`
    min-height: 40px;
    margin: 0;
    width: 100%;
    text-align: left;
    background: none;
    padding: 0 16px;
    padding-right: 46px;
    cursor: pointer !important;
    border-radius: 4px;
    border: 2px solid transparent;

    > * {
        cursor: pointer !important;
    }

    &:focus {
        outline: none;
        border-color: ${color.Blue.B80};
    }

    &:hover {
        border-radius: 0;
        background: ${color.Grey.G10};
    }
`;
